import type { WidgetItem } from '@/features/Markets';

function hasStringGraphType(meta: unknown): meta is { graphType: string } {
  return (
    !!meta &&
    typeof meta === 'object' &&
    'graphType' in meta &&
    typeof (meta as { graphType?: unknown }).graphType === 'string'
  );
}

export default function getWidgetType(widget: WidgetItem) {
  let type;

  if (widget.type === 'graph') {
    const meta = widget.definition.metadata as unknown;
    if (hasStringGraphType(meta)) {
      type = meta.graphType;
    } else {
      type = 'simple';
    }
  } else {
    type = widget.type;
  }

  return type;
}
